import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LogLevel } from "abweb/utils/log/LogLevel";
import { SourceMapUtils } from "abweb/utils/SourceMapUtils";
export class LogRecord {
  constructor(level, module, message, error = null) {
    _defineProperty(this, "time", void 0);
    _defineProperty(this, "error", void 0);
    _defineProperty(this, "cleanedStack", null);
    this.level = level;
    this.module = module;
    this.message = message;
    this.error = error;
    this.time = new Date();
  }
  get mergedMessage() {
    let stack;
    if (this.cleanedStack) {
      // If cleanedStack is set, use it
      stack = this.cleanedStack;
    } else if (this.error && this.error.stack) {
      // attempt to get the stack from the error
      stack = this.error.stack.split("\n");
    } else {
      stack = [];
    }

    // remove the boring parts
    let level = 0;
    while (level < stack.length && stack[level].match(/Log|^Error$/)) {
      level++;
    }
    stack = stack.slice(level);
    return this.module + " " + this.message + (stack.length > 0 ? "\r\n" + stack.join("\r\n") + "\r\n" : "");
  }

  /**
   * clean this.error stack based on source maps
   */
  async cleanStack() {
    const stack = await SourceMapUtils.cleanErrorStack(this.error);
    this.cleanedStack = stack.split("\n");
  }
  toString() {
    // Note that Edge 15 and earlier has/had a bug where it would inject bidirectional formatting characters into the
    // dates. See this article, assuming the internet continues to serve it up: https://github.com/microsoft/ChakraCore/issues/599
    let timestamp = this.time.toLocaleTimeString("en-US", {
      hour12: false
    }).replace(/\u200e/g, "");
    return timestamp + " " + LogLevel[this.level].toUpperCase() + " " + this.mergedMessage;
  }

  /** Use native console.{error,warn,info,debug,log} functionality to log the LogRecord instance */
  logToConsole() {
    switch (this.level) {
      case LogLevel.error:
        console.error(this.mergedMessage);
        break;
      case LogLevel.warn:
        console.warn(this.mergedMessage);
        break;
      case LogLevel.info:
        console.info(this.mergedMessage);
        break;
      case LogLevel.debug:
        console.debug(this.mergedMessage);
        break;
      case LogLevel.none:
        console.log(this.mergedMessage);
        break;
      default:
        // noinspection JSUnusedLocalSymbols
        const shouldNeverGetHere = this.level;
      // compiler will fail if above cases don't cover all LogLevel enum values
    }
  }
}
//# sourceMappingURL=LogRecord.js.map
